<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('zipdownloadTask') }}</span>
        <span STYLE="font-size: 12px;color:#FF0000;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如果您批量下载的工资条任务未展示或者文件状态为“生成中”，请您稍后<span STYLE="color:#118EE9;">{{ $t('reflash') }}</span>界面重试!</span>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="getData()"> {{ $t('reflash') }}</el-button>
        <el-button plain class="button-v2" @click="$back">{{ $t('back') }}</el-button>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
        @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4" >
            <span v-if="row.payslipStatus==='可下载'||row.payslipStatus==='download'" class="text-button" @click="downloadPdfZip(row)">{{ $t('download') }}</span>
          </div>
        </template>
      </air-table>
      
      <!--<vxe-pager-->
        <!--class="pager-v2"-->
        <!--background-->
        <!--:current-page.sync="queryParams.page"-->
        <!--:page-size.sync="queryParams.limit"-->
        <!--:total="total"-->
        <!--:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"-->
        <!--@page-change="getData"-->
      <!--&gt;</vxe-pager>-->
      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
    </div>
    
    
  </div>
</template>

<script>
  import * as api from '@/api/wage/payslip'
  import { downloadFileByUrl } from '@/util/util';
  
  export default {
    name: 'ZipDownloadData',
    components: {
    
    },
    data() {
      return {
        loading: true,
        // salaryDetailIds：this.$route.query.salaryDetailIds,
        queryParams: {
          page: 1,
          limit: 20,
        },
        total: 0,
        columns: [
          {title: this.$t('userName'), field: 'zipDesc', minWidth: 150, filterType: 'input'},
          {title: this.$t('createTime'), field: 'createTime', minWidth: 150, filterType: 'input'},
          {title: this.$t('status'), field: 'payslipStatus', minWidth: 150, filterType: 'input'},
        ],
        tableData: [],
        form: {}
      }
    },
    computed: {
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.getData()
      },
      getData() {
        this.loading = true
        if(this.queryParams.payslipStatus==='download'){
          this.queryParams.payslipStatus='可下载'
        }
        if(this.queryParams.payslipStatus==='preparing'){
          this.queryParams.payslipStatus='正在生成。。。'
        }
        api.reflashData(this.queryParams).then(res => {
          this.tableData = res.data.data.records
          this.tableData.forEach(item => {
            if (item.payslipStatus === '可下载'){
              item.payslipStatus =this.$t('enabledownload')
            }
            if (item.payslipStatus === '正在生成。。。'){
              item.payslipStatus =this.$t('preparing')
            }
          })
          this.total = res.data.data.total
          this.queryParams.total = res.data.data.total
          this.loading = false
        })
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData}
        this.getData()
      },
      downloadPdfZip(item) {
        downloadFileByUrl(item.zipPath, item.fileName)
      },
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
